import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const removePrimaryResources = createAsyncThunk(
  "projects/removePrimaryResources",
  async (quotationId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token"); // assuming JWT token stored
      const response = await axiosInstance.put(
        `${BackendURL}/managerProjectRequested/remove-primary/${encodeURIComponent(quotationId)}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to remove primary resources"
      );
    }
  }
);

const removePrimaryResourcesSlice = createSlice({
  name: "removePrimaryResources",
  initialState: {
    loading: false,
    success: false,
    error: null,
    message: null,
    modifiedCount: 0,
  },
  reducers: {
    resetRemovePrimaryState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
      state.modifiedCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(removePrimaryResources.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
        state.modifiedCount = 0;
      })
      .addCase(removePrimaryResources.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload?.message || "Primary resources removed successfully";
        state.modifiedCount = action.payload?.modifiedCount || 0;
      })
      .addCase(removePrimaryResources.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetRemovePrimaryState } = removePrimaryResourcesSlice.actions;
export default removePrimaryResourcesSlice.reducer;
